module.exports = __webpack_public_path__ + "static/img/nutriologaWork.14d66df6.webp";